<script>
import router from "@/router";
import { layoutComputed } from "@/state/helpers";

import NavBar from "@/components/nav-bar";
import SideBar from "@/components/side-bar";
import Footer from "@/components/footer";
import axios from "axios";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
/**
 * Vertical layout
 */
export default {
  components: { NavBar, SideBar, Footer, quillEditor },
  data() {
    return {
      type: this.$store ? this.$store.state.layout.leftSidebarType : null || null,
      width: this.$store ? this.$store.state.layout.layoutWidth : null || null,
      isMenuCondensed: false,
      showHelp: false,
      imageFile: '',
      page_loader: false,
      loader2: false,
      message: '',
      editorOptions: {
        modules: {
          toolbar: [
            [{ size: ["small", false, "large", "huge"] }], // Font size
            ["bold", "italic", "underline"], // Formatting buttons
            [{ list: "ordered" }, { list: "bullet" }], // Lists
            ["clean"], // Clear formatting
          ],
        }
      }
    };
  },
  computed: {
    ...layoutComputed,
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
    document.body.classList.remove("auth-body-bg");
  },
  methods: {
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },

    handleImageUpload(event) {
      this.imageFile = event.target.files[0];
    },

    async sendMessage() {
      this.loader2 = true;
      const userData = JSON.parse(localStorage.getItem('user'));
      let formData = new FormData();
      formData.append('business', userData.member.business);
      formData.append('businessName', userData.business);
      formData.append('clientID', userData.member.id);
      formData.append('clientName', userData.member.name);
      formData.append('contact', userData.member.telephone);
      formData.append('email', userData.member.email);
      formData.append('software', '2'); // 2 for Tandika Software
      formData.append('message', this.message);
      formData.append('attachment', this.imageFile);

      try {
        await axios.post('https://mtahelpdeskadmin.afrimedsolutions.com/api/inquiry', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(response => {
          if (response.status == 200) {
            this.message = '';
            this.imageFile = '';
            this.loader2 = false;
          }
        });
      } catch (error) {
        this.loader2 = false;
        alert(error);

      }
    }
  },

  mounted() {
    setTimeout(() => {
      this.page_loader = false; // Hide preloader after 0.1 seconds
    }, 100);
  },
};
</script>

<template>
  <div>

    <div id="layout-wrapper">
      <NavBar />
      <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth"
        style="background-color: black;" />
      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <!-- <transition name="fade"> -->
            <div v-if="page_loader" id="preloader">
              <div id="status">
                <div class="spinner-chase">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
          <!-- </transition> -->
          <div class="container-fluid">
            <slot />
          </div>
        </div>
        <div v-if="showHelp" class="help-space bg-white rounded shadow-lg p-4">
          <h3 class="text-center text-primary fw-bold">MTA Help Desk</h3>
          <hr>
          <p><span class="fw-bold">Welcome to our Help & Support Space! </span><br>
            We’re here to assist you with any questions, issues, or feedback you may have. Our team is ready to help.
          </p>

          <form @submit.prevent="sendMessage">
            <label for="message" class="text-primary mb-0">Message:</label>
            <!-- <textarea required class="form-control" v-model="message" id="message" rows="4"></textarea> -->
            <quillEditor class="quill-editor rounded" :options="editorOptions" v-model="message" required
              theme="snow" />
            <br>
            <input @change="handleImageUpload" type="file" accept="image/*" class="form-control form-control-sm">
            <div class="py-2">
              <button class="btn w-100 btn-primary" :disabled="loader2" type="submit">{{ loader2 ? '' : 'Send Message'
                }}
                <b-spinner v-if="loader2" small></b-spinner></button>
            </div>
          </form>
        </div>
        <!-- <div @click="showHelp = !showHelp" class="text-end">
          <button class="shadow-lg fs-4 fw-bold help-button btn btn-primary btn-sm">
            <span v-if="!showHelp" class="mdi mdi-help"></span>
            <span v-else class="mdi mdi-close"></span>
          </button>
        </div> -->
        <Footer />
      </div>
      <!-- <RightBar /> -->
    </div>
  </div>
</template>

<style>
.help-button {
  position: fixed;
  bottom: 25px;
  right: 25px;
  width: 40px;
  height: 40px;
  z-index: 100;
  border-radius: 50%;
}

.help-space {
  position: fixed;
  bottom: 40px;
  width: 35%;
  right: 40px;
  z-index: 100;
  border-radius: 50%;
}

.quill-editor .ql-editor {
  min-height: 120px;
  max-height: 300px;
  overflow-y: auto;
}

/* https://mtahelpdeskadmin.afrimedsolutions.com/api */
</style>
